import $ from "jquery"
import EntityNode from "./EntityNode"
import SimpleTooltip from "../../../SimpleTooltip"
import messageResource from "../../../messageResource"
import EditButton from "../../EditButton"
import {setEventPreventHidingEditCustomerSlidingPanel} from "../../../panels/utils"

export default class CustomerNode extends EntityNode {

    constructor({
        tokensHighlighter,
        customer,
        collapsed,
        onClick = () => {},
    }) {
        super({tokensHighlighter, onClick})
        this.customer = customer
        this.collapsed = collapsed
    }

    templateHtml() {
        return "<div class='node customerNode'>" +
               "  <div class='collapseButton'></div>" +
               "  <div class='icon'></div>" +
               "  <div class='title'>" +
               "    <div class='text'><%=title%></div>" +
               "    <div class='archivedLabel'><%=archivedLabel%></div>" +
               "  </div>" +
               "</div>";
    }

    afterRender() {
        super.afterRender();

        let self = this;
        this.$collapseButton = this.find(".collapseButton");
        this.$collapseButton.click(function() {
            const newCollapsedValue = !self.collapsed;
            self.setCollapsed(newCollapsedValue);
            $(self).trigger("collapse", newCollapsedValue);
        });

        if (!this.editButton) {
            this.editButton = new EditButton(this.$el).init();
        }
        this.editButton.setClickHandler((e) => {this._editButtonClickHandler(e)});

        const editTooltip = this.editTooltip();
        editTooltip.subscribeToMouseEvents(this.editButton.$el);
        $(this).on("hide_tooltip", function() { editTooltip.hide() });

        this.renderInitialState()
    }

    _editButtonClickHandler(e) {
        setEventPreventHidingEditCustomerSlidingPanel(e);
        $(document).trigger("taskManagement_viewCustomer", this.customer.id);
        $(this).trigger("hide_tooltip");
        this.preventNextClick = true;
    }

    update() {
        if (this.rendered) {
            super.update();
            this.$el.toggleClass("collapsed", this.collapsed);
            this.$el.toggleClass("archived", this.customer.archived);
        }
    }

    messageKeys() {
        return {
            archivedLabel: "common.archived"
        }
    }

    title() {
        return this.customer.name;
    }

    isCollapsed() {
        return this.collapsed
    }

    setCollapsed(collapsed) {
        this.collapsed = collapsed;
        this.update();
    }

    getId() {
        return this.customer.id
    }

    editTooltip() {
        if (!CustomerNode.tooltip) {
            CustomerNode.tooltip = new SimpleTooltip({
                text: messageResource.getMessage('task.list.tooltip.customer_edit'),
            }).init($('body'))
        }
        return CustomerNode.tooltip
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/customersProjectsPanel/tree/CustomerNode.js